// extracted by mini-css-extract-plugin
export default {"checkbox_wrapper_31":"checkBox_checkbox_wrapper_31__gtd8p","check":"checkBox_check__ShNEZ","background":"checkBox_background__VSD29","stroke":"checkBox_stroke__LhHP+"};